import { api } from "@/lib/api/axios";
import { IDocumento, IDocumentoEnhanced, IDocumentStats } from "@/types/documento";

const DOCUMENTOS_API_PATH = "/documentos";

export const documentosService = {
  findAll: async () => {
    return api.get<IDocumentoEnhanced[]>(`${DOCUMENTOS_API_PATH}`);
  },

  findOne: async (id: number) => {
    return api.get<IDocumentoEnhanced>(`${DOCUMENTOS_API_PATH}/${id}`);
  },

  create: async (data: Omit<IDocumento, "id">) => {
    return api.post<IDocumento>(`${DOCUMENTOS_API_PATH}`, data);
  },

  update: async (id: number, data: Partial<IDocumento>) => {
    return api.patch<IDocumento>(`${DOCUMENTOS_API_PATH}/${id}`, data);
  },

  delete: async (id: number) => {
    return api.delete<{ message: string }>(`${DOCUMENTOS_API_PATH}/${id}`);
  },

  upload: async (data: FormData) => {
    return api.post<IDocumento>(`${DOCUMENTOS_API_PATH}/upload`, data, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },

  getStats: async () => {
    return api.get<IDocumentStats[]>(`${DOCUMENTOS_API_PATH}/stats`);
  },
};
